import React, { FC, useMemo } from "react"
import { ContestResponse } from "@jnext/ts-axios-contestformat"
import { useTranslation } from "react-i18next"
import './../JCardEvent/JCardEventTemplate.scss'
import { JCMSCard, JCMSCardProps } from "../../JCMSCard"
import { useJCommonContext } from "../../../JCommonProvider"
import { pointsToJBadgeItem } from "../../../lib"
import { CMSImage, CMSStaticSection } from "../../../models"
import { checkIfRenderBadgePoint, getContestComminucationText } from "../../../lib"

let defaultTimeZone = localStorage?.getItem('defaultTimeZone') ? localStorage?.getItem('defaultTimeZone') : 'Europe/Rome';

export interface JCardContestProps extends ContestResponse {
    cardProps?: JCMSCardProps
}

export const JCardContest: FC<JCardContestProps> = ({ cardProps, ...contest }) => {
    const { t: translate } = useTranslation();
    const {navigate} = useJCommonContext()

    const section: CMSStaticSection.Card = useMemo(() => (
        contestToSectionCard(contest, translate)
    ), [contest])

    return (
        <JCMSCard 
            className={`jcms-card-contest jcms-card-event-template contest-status--${contest?.contest?.status?.toLocaleLowerCase()} contest-id--${contest?.contest?.logicId}`}
            onClick={() => navigate('CONTEST_DETAILS', {contestLogicId: contest.contest?.logicId})}
            {...section} 
            {...(cardProps || {})}
        />
    )
}

export function contestToSectionCard(contest: ContestResponse, translate: (str: string, params?: Record<string, any>) => string) {
    const _section: CMSStaticSection.Card = {
        enabled: true,
        title: contest.contestCms?.previewTitle ?? contest.contestCms?.title,
        text: contest.contestCms?.shortDescription,
        subTitle: translate('CONTEST_TYPE_' + contest.contest?.type).toUpperCase(),
        type: CMSStaticSection.Types.STATIC_CARD,
        options: {
            headerContent: getContestComminucationText(contest, translate, defaultTimeZone ?? 'Europe/Rome')

        }
    }
    if (contest.contest?.costs && checkIfRenderBadgePoint(contest.contest.costs) && _section.options) {
        _section.options.walletBadge = pointsToJBadgeItem(contest.contest.costs)
    }
    if (contest.contestCms?.thumbNailImage) {
        _section.image = contest.contestCms?.thumbNailImage as CMSImage[]
    }
    if (contest.contestCms?.baseImage && _section.sections?.[0]) {
        _section.sections[0].image =contest.contestCms?.baseImage as CMSImage[]
    }
    return _section
}